import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: createCustomBaseQuery(
    `${API_BASE_URL}/payment/`
  ),
  endpoints: (builder) => ({
    getPricing: builder.query<any, void>({
      query: () => ({
        url: "pricing",
        method: "GET",
      }),
    }),
    getCheckout: builder.query<any, string>({
      query: (priceId) => ({
        url: `checkout/${priceId}`,
        method: "GET",
      }),
    }),
    getTransactions: builder.query<any, void>({
      query: () => ({
        url: "transactions",
        method: "GET",
      }),
    }),
    getInvoice: builder.query<any, string>({
      query: (transactionId) => ({
        url: `transactions/${transactionId}/invoice`,
        method: "GET",
      }),
    }),
    storeCustomer: builder.mutation<any, void>({
      query: () => ({
        url: "customer",
        method: "GET",
      }),
    }),
    getSubscriptionDetails: builder.query<any, string | void>({
      query: (userId) => ({
        url: "subscription/details",
        method: "GET",
      }),
    }),
    cancelSubscription: builder.query<any, void>({
      query: () => ({
        url: "subscription/cancel",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetPricingQuery,
  useLazyGetPricingQuery,
  useLazyGetCheckoutQuery,
  useGetTransactionsQuery,
  useLazyGetInvoiceQuery,
  useStoreCustomerMutation,
  useGetSubscriptionDetailsQuery,
  useLazyCancelSubscriptionQuery,
} = paymentApi;
